import React from 'react';
import {useTheme} from '@mui/material';
import {Text} from 'components/text';

type Props = {
  title: string;
  color?: string;
};

export const HealthSubtitle: React.FC<Props> = ({title, color}) => {
  const {palette} = useTheme();
  return (
    <Text variant="body2" sx={{color: color ?? palette.primary.contrastText}}>
      {title}
    </Text>
  );
};
